import { ComponentModes, SubstitutionsTypes } from 'shared/enums';

export const getTitle = (modeType?: ComponentModes, subtitutionType?: SubstitutionsTypes): string => {
  if (subtitutionType === SubstitutionsTypes.acting && modeType === ComponentModes.create) {
    return 'Назначить И. О';
  }
  if (subtitutionType === SubstitutionsTypes.deputy && modeType === ComponentModes.create) {
    return 'Назначить замещающего';
  }
  if (subtitutionType === SubstitutionsTypes.acting && modeType === ComponentModes.edit) {
    return 'Редактирование';
  }
  if (modeType === ComponentModes.add) {
    return 'Добавить замещение';
  }
  return '';
};
